import React, { useState } from "react";
import { FixedTitleContainer, NoEarningsContainer } from "./styles";
import { TransactionBody, styles } from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import { erc721ContractAddress, openseaURL } from "./Earnings";
import { IconButton } from "@mui/material";
import { Earning, NftTableProps } from "./types";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { LightTooltip } from "../LightToolTip/LightToolTip";
import { FONT_FAMILY, TEXT_COLOR } from "../../theme";

const NftTable: React.FC<NftTableProps> = ({
  columns,
  title,
  handleSort,
  earnings,
  etherscanURL,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <>
      <div style={styles.titleContainer}>
        <h3 style={{ fontWeight: "bold" }}>{title}</h3>
      </div>

      <div style={{ fontFamily: FONT_FAMILY }} className="container-earn">
        <div style={{ minWidth: "1450px", color: TEXT_COLOR }}>
          <TransactionBody>
            <div
              style={
                title === "My NFTs"
                  ? styles.myNftTable
                  : styles.collaboratedNFTsTable
              }
            >
              {columns.map((el, i) => {
                let salesPrice = <div key={i}></div>;
                if (el === "Sale Price" || el === "Collaboration %") {
                  salesPrice = (
                    <div
                      style={{ fontFamily: FONT_FAMILY }}
                      key={i}
                      className="form-header-text"
                    >
                      {el}
                      <FontAwesomeIcon
                        style={{ marginLeft: "10px" }}
                        icon={faSort}
                        onClick={() => handleSort()}
                      />
                    </div>
                  );
                } else if (el === "My Earnings") {
                  salesPrice = (
                    <div
                      key={i}
                      style={{ fontFamily: FONT_FAMILY }}
                      className="form-header-text"
                      onClick={() =>
                        setShowTooltip((showTooltip) => !showTooltip)
                      }
                    >
                      {el}
                      <div
                        style={{ display: "inline" }}
                        onMouseOver={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                        onClick={() => setShowTooltip((prev) => !prev)}
                      >
                        <LightTooltip
                          title="Total earning minus Gas fees and OmMuse fee"
                          placement="top"
                          open={showTooltip}
                          onMouseOver={() => setShowTooltip(true)}
                          onMouseLeave={() => setShowTooltip(false)}
                        >
                          <IconButton disableRipple>
                            <HelpOutlineIcon
                              color="info"
                              style={{ height: 18, width: 18 }}
                            />
                          </IconButton>
                        </LightTooltip>
                      </div>
                      <FontAwesomeIcon
                        icon={faSort}
                        onClick={() => handleSort()}
                      />
                    </div>
                  );
                } else {
                  salesPrice =
                    el === "Title" ? (
                      <FixedTitleContainer key={el}>{el}</FixedTitleContainer>
                    ) : (
                      <div key={i}>{el}</div>
                    );
                }
                return salesPrice;
              })}
            </div>
            <hr style={{ color: "#A4A4A4" }} />
            {earnings.length === 0 ? (
              <NoEarningsContainer>No earnings available</NoEarningsContainer>
            ) : (
              earnings.map((earning: Earning) => {
                let openseaRender = <div></div>;
                if (earning.token !== "") {
                  openseaRender = (
                    <span>
                      <a
                        href={`${openseaURL}/${erc721ContractAddress}/${earning.token}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src="/assets/images/opensea.svg"
                          alt="openseea"
                          style={{ width: 17, marginLeft: 5 }}
                        />
                      </a>
                    </span>
                  );
                }
                return (
                  <div key={earning.token}>
                    <div
                      style={
                        title === "My NFTs"
                          ? styles.myNftTable
                          : styles.collaboratedNFTsTable
                      }
                    >
                      <div className="form-text" style={styles.FixedTitleValue}>
                        {earning.title}
                      </div>
                      <div
                        className="form-text"
                        style={{ color: TEXT_COLOR, fontFamily: FONT_FAMILY }}
                      >
                        {earning.artist}
                      </div>
                      <div
                        className="form-text"
                        style={{ color: TEXT_COLOR, fontFamily: FONT_FAMILY }}
                      >
                        {earning.state}
                      </div>
                      <div
                        className="form-text"
                        style={{ color: TEXT_COLOR, fontFamily: FONT_FAMILY }}
                      >
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {openseaRender}
                        </div>
                      </div>
                      <div
                        style={{ fontFamily: FONT_FAMILY }}
                        className="form-text"
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            color: TEXT_COLOR,
                          }}
                        >
                          <span>{earning.price}</span>
                          <img
                            src="/assets/images/ethereum.svg"
                            alt="ethereum"
                            style={styles.ethereumImgContainer}
                          />
                        </div>
                      </div>
                      <div
                        style={{ fontFamily: FONT_FAMILY }}
                        className="form-text"
                      >
                        <div style={styles.ethereumImgContainer}>
                          <span>{earning.splitBalance}</span>
                          <img
                            src="/assets/images/ethereum.svg"
                            alt="ethereum"
                            style={styles.ethereumImg}
                          />
                        </div>
                      </div>
                      {title === "Collaborated NFTs" ? (
                        <>
                          <div
                            className="form-text"
                            style={{
                              color: TEXT_COLOR,
                              fontFamily: FONT_FAMILY,
                            }}
                          >
                            {earning.splitPercent}%
                          </div>
                          <div className="form-text">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                fontFamily: FONT_FAMILY,
                              }}
                            >
                              <span>
                                <a
                                  href={`${etherscanURL}/${earning.splitAddress}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <div className="code">
                                    {earning.splitAddress
                                      ? `${earning.splitAddress.slice(
                                          0,
                                          10
                                        )}...${earning.splitAddress.slice(-10)}`
                                      : ""}
                                  </div>
                                </a>
                              </span>

                              <img
                                src="/assets/images/etherscan-logo.png"
                                alt="openseea"
                                style={styles.openSeaImg}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    <hr
                      style={{ color: TEXT_COLOR, border: "1px solid white" }}
                    />
                  </div>
                );
              })
            )}
          </TransactionBody>
        </div>
      </div>
    </>
  );
};

export default NftTable;
